import sitesAndLocationDataConfigApi from '@/api/config/sitesAndLocationDataConfigApi'
import { queryKeys } from '@/constant/common'
import { UpdateLocation } from '@/types/siteLocation'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'

async function updateLocation(payload: UpdateLocation): Promise<void> {
  await sitesAndLocationDataConfigApi.updateLocation(payload)
}

function useUpdateLocation() {
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()
  return useMutation((payload: UpdateLocation) => updateLocation(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.siteLocation])
      toast.success('Update Location Success')
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
  })
}

export default useUpdateLocation
